import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CartRow, CheckoutObject, GungModalService } from 'gung-standard';
import { JeevesDeliveryLocation } from 'gung-standard-jeeves';
import { HlDisplayAddEditDeliveryLocationModalComponent } from '../components/hl-display-add-edit-delivery-location-modal/hl-display-add-edit-delivery-location-modal.component';
import { HlDisplayEditCheckoutLineModalComponent } from '../components/checkout/hl-display-edit-checkout-line-modal/hl-display-edit-checkout-line-modal.component';
import { HlDisplayCustomerServiceEditTransportDetailsModalComponent } from '../components/checkout/hl-display-customer-service-edit-transport-details-modal/hl-display-customer-service-edit-transport-details-modal.component';

@Injectable({
  providedIn: 'root'
})
export class HlDisplayModalService extends GungModalService {
  openAddEditHlDisplayDeliveryLocation(selectedCustomerId: string, deliveryLocation?: JeevesDeliveryLocation, modalOption?: NgbModalOptions): Promise<any> {
    const option: NgbModalOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      ...modalOption
    };

    const ref = this.ngbModal.open(HlDisplayAddEditDeliveryLocationModalComponent, option);
    const componentInstance = ref.componentInstance as HlDisplayAddEditDeliveryLocationModalComponent;
    componentInstance.selectedCustomerId = selectedCustomerId;
    componentInstance.deliveryLocation = deliveryLocation;

    return ref.result;
  }

  openHlDisplayEditCheckoutLineModal(cartRow: CartRow, modalOption?: NgbModalOptions): Promise<any> {
    const option: NgbModalOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      ...modalOption
    };

    const ref = this.ngbModal.open(HlDisplayEditCheckoutLineModalComponent, option);
    const componentInstance = ref.componentInstance as HlDisplayEditCheckoutLineModalComponent;
    componentInstance.cartRow = cartRow;

    return ref.result;
  }

  openHlDisplayEditTransportDetailsModal(checkout: CheckoutObject, modalOption?: NgbModalOptions): Promise<any> {
    const option: NgbModalOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      ...modalOption
    };

    const ref = this.ngbModal.open(HlDisplayCustomerServiceEditTransportDetailsModalComponent, option);
    const componentInstance = ref.componentInstance as HlDisplayCustomerServiceEditTransportDetailsModalComponent;
    componentInstance.checkout = checkout;

    return ref.result;
  }
}
